import React from "react";
import { Plus } from "lucide-react";

export const BLANK_COLOURWAY = {
  product_slug: "pritch-grip-sock",
  slug: "",
  name: "",
  hex: "#F4F6F8",
  description: "",
  season: "FW26",
  stock: 100,
  featured_this_season: false,
  is_active: true,
  sort_order: 0,
};

const FIELD_KEYS = ["slug", "name", "hex", "season"];

/** Inline "create colourway" form rendered above the table. */
const ColourwayCreateRow = ({ draft, setDraft, products, onCreate }) => (
  <div
    className="bg-white border border-ink p-4 mb-4 grid grid-cols-2 md:grid-cols-4 gap-3 items-end"
    data-testid="cw-create-row"
  >
    <label className="block col-span-2">
      <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
        Product
      </span>
      <select
        value={draft.product_slug}
        onChange={(e) => setDraft({ ...draft, product_slug: e.target.value })}
        className="w-full border border-line px-3 py-2 bg-chalk"
      >
        {products.map((p) => (
          <option key={p.slug} value={p.slug}>
            {p.name}
          </option>
        ))}
      </select>
    </label>
    {FIELD_KEYS.map((k) => (
      <label key={k} className="block">
        <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
          {k}
        </span>
        <input
          value={draft[k]}
          onChange={(e) => setDraft({ ...draft, [k]: e.target.value })}
          className="w-full border border-line px-3 py-2 bg-chalk"
        />
      </label>
    ))}
    <label className="block">
      <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
        Stock
      </span>
      <input
        type="number"
        min="0"
        value={draft.stock}
        onChange={(e) => setDraft({ ...draft, stock: e.target.value })}
        className="w-full border border-line px-3 py-2 bg-chalk"
      />
    </label>
    <label className="block col-span-2">
      <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
        Description
      </span>
      <input
        value={draft.description}
        onChange={(e) => setDraft({ ...draft, description: e.target.value })}
        className="w-full border border-line px-3 py-2 bg-chalk"
      />
    </label>
    <button
      type="button"
      onClick={onCreate}
      className="btn-primary"
      data-testid="cw-create-submit"
    >
      <Plus size={12} className="mr-1" /> Create
    </button>
  </div>
);

export default ColourwayCreateRow;
